/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Per_User_MoInputs */



/**
* | output |
* | --- |
* | "/user/mo" |
*
* @param {Sub_Addons_Per_User_MoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_per_user_mo = /** @type {((inputs?: Sub_Addons_Per_User_MoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Per_User_MoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("/Nutzer/Mo.")
	return /** @type {LocalizedString} */ ("/user/mo")
});